







/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR
// GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR


const GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR= createAsyncThunk(
  "getAllReapprovalCustomersWithCreatorAndRejector/getAllReapprovalCustomersWithCreatorAndRejector",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllReapprovalCustomersWithCreatorAndRejectorSlice = createSlice({
  name: "getAllReapprovalCustomersWithCreatorAndRejectorSlice",
  initialState: {
    getAllReapprovalCustomersWithCreatorAndRejector: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllReapprovalCustomersWithCreatorAndRejector: (state) => {
        state.getAllReapprovalCustomersWithCreatorAndRejector.loading = false
        state.getAllReapprovalCustomersWithCreatorAndRejector.error = false
        state.getAllReapprovalCustomersWithCreatorAndRejector.data = []
        state.getAllReapprovalCustomersWithCreatorAndRejector.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR.fulfilled, (state, action) => {
      state.getAllReapprovalCustomersWithCreatorAndRejector = {
        ...state.getAllReapprovalCustomersWithCreatorAndRejector,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR.pending, (state, action) => {
      state.getAllReapprovalCustomersWithCreatorAndRejector = {
        ...state.getAllReapprovalCustomersWithCreatorAndRejector,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR.rejected, (state, action) => {
      state.getAllReapprovalCustomersWithCreatorAndRejector = {
        ...state.getAllReapprovalCustomersWithCreatorAndRejector,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllReapprovalCustomersWithCreatorAndRejectorAction = {
    GETALLREAPPOVALCUSTOMERSWITHCREATORANDREJECTOR,
};

export { getAllReapprovalCustomersWithCreatorAndRejectorAction };
export default getAllReapprovalCustomersWithCreatorAndRejectorSlice.reducer;
export const {setInitialStateOfgetAllReapprovalCustomersWithCreatorAndRejector} = getAllReapprovalCustomersWithCreatorAndRejectorSlice.actions
